import React from 'react';

const AmexIcon = () => (
  <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="16" rx="2" fill="#1F72CD"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M4.66211 4.5H7.11211L7.73211 5.87778H9.27211L9.59878 4.5H13.4188L14.8588 7.13778L16.1888 4.5H19.7188L16.0688 8.40444L19.7188 12.3089H17.3988L15.8588 9.47778L14.3188 12.3089H6.95211L6.33211 10.9311H3.27211L2.65211 12.3089H0.0188141L3.66211 4.5H4.66211ZM3.98211 9.55556L5.68211 5.59556L7.38211 9.55556H3.98211ZM9.59878 10.3511H12.4188L13.9588 7.52222L15.5021 10.3511H16.8321L14.6488 7.41778L16.8321 4.5H15.5021L13.9588 7.32889L12.4188 4.5H9.59878V10.3511Z" fill="white"/>
  </svg>
);

export default AmexIcon; 